import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/codebuild/output/src1628444838/src/portal-web-v2/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1628444838/src/portal-web-v2/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1628444838/src/portal-web-v2/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1628444838/src/portal-web-v2/src/components/reviews/Reviews.jsx");
